import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  RadioGroup,
  Radio,
  FormControlLabel,
  Divider,
  Chip,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  IconButton,
  Stack,
  Checkbox,
  ListItemText,
  InputAdornment,
  Autocomplete,
} from '@mui/material';
import React from 'react';
import Header from '../components/Admin/header/Header';
import Sidebar from '../components/Admin/Sidebar/Sidebar';
import { Search, UploadIcon, UserPlus, X } from 'lucide-react';
import AddIcon from '@mui/icons-material/Add';

function BedTransfer() {
  return (
    <Container maxWidth={false} disableGutters>
      <Header />
      <Box sx={{ display: 'flex' }}>
        <Box sx={{}}>
          <Sidebar />
        </Box>
        <Box sx={{ width: '100%' }}>
          {/* Search */}

          <Box
            sx={{
              paddingTop: '20px',
              display: 'flex',
              justifyContent: 'space-between',
              marginBottom: '20px',
              marginRight: '80px',
            }}
          >
            <Box
              sx={{
                display: 'flex',
                backgroundColor: 'white',
                border: '1px solid #e0e0e0',
                borderRadius: '4px',
              }}
            >
              <select className="uid-select">
                <option value="UHID">UHID</option>
                <option value="name">Patient Name</option>
                <option value="contact">Contact Number</option>
              </select>
              <div className="search-input-wrapper">
                <Search className="search-icon" size={20} />
                <input
                  type="text"
                  placeholder={`Search by `}
                  className="search-input"
                />
                {true && (
                  <button
                    style={{
                      position: 'absolute',
                      right: '10px',
                      background: 'none',
                      border: 'none',
                      cursor: 'pointer',
                      color: '#999',
                    }}
                    className="clear-search"
                  >
                    <X size={16} />
                  </button>
                )}
              </div>
            </Box>
            <Box>
              <button className="patient-registration">
                <UserPlus size={20} />
                Patient Registration
              </button>
            </Box>
          </Box>

          {/* Patient Details */}
          <Box
            sx={{
              padding: 2,
              borderRadius: 2,
              marginRight: '90px',
            }}
          >
            {/* Patient Information */}
            <Box
              sx={{
                backgroundColor: '#fff',
                borderRadius: 2,
                display: 'flex',
                gap: 4,
              }}
            >
              <Box
                sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}
              >
                {/* Personal Information */}

                <Box
                  sx={{
                    padding: 2,
                    border: '1px solid #ccd4da',
                    borderRadius: 2,
                    marginBottom: 2,
                  }}
                >
                  <Typography variant="subtitle1" marginBottom={2} color="grey">
                    Patient Information
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                    <TextField
                      label="UHID"
                      value="#46740303"
                      InputProps={{ readOnly: true }}
                      sx={{ flex: '1 1 20%' }}
                    />
                    <TextField
                      label="Patient Name"
                      value="John Wick"
                      InputProps={{ readOnly: true }}
                      sx={{ flex: '1 1 20%' }}
                    />
                    <TextField
                      label="Age"
                      value="34"
                      InputProps={{ readOnly: true }}
                      sx={{ flex: '1 1 20%' }}
                    />
                    <TextField
                      label="Gender"
                      value="Mle"
                      InputProps={{ readOnly: true }}
                      sx={{ flex: '1 1 20%' }}
                    />{' '}
                  </Box>
                </Box>

                <Box
                  sx={{
                    padding: 2,
                    border: '1px solid #ccd4da',
                    borderRadius: 2,
                    marginBottom: 2,
                  }}
                >
                  <Typography variant="subtitle1" marginBottom={2} color="grey">
                    Current Ward Information
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                    <TextField
                      label="Current Ward"
                      value="ICU"
                      InputProps={{ readOnly: true }}
                      sx={{ flex: '1 1 20%' }}
                    />
                    <TextField
                      label="Room Number"
                      value="203"
                      InputProps={{ readOnly: true }}
                      sx={{ flex: '1 1 20%' }}
                    />
                    <TextField
                      label="Bed Number"
                      value="8"
                      InputProps={{ readOnly: true }}
                      sx={{ flex: '1 1 20%' }}
                    />
                    <TextField
                      label="Admission Date"
                      value="09/01/2024"
                      InputProps={{ readOnly: true }}
                      sx={{ flex: '1 1 20%' }}
                    />{' '}
                  </Box>
                </Box>

                {/* New Ward Info*/}
                <Box
                  sx={{
                    padding: 2,
                    backgroundColor: '#f5faff',
                    borderRadius: 2,
                    marginBottom: 2,
                  }}
                >
                  <Typography variant="subtitle1" color="grey" marginBottom={2}>
                    New Ward Information
                  </Typography>
                  <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                    <FormControl sx={{ flex: '1 1 20%' }}>
                      <InputLabel
                        sx={{ backgroundColor: '#f5faff', padding: '0px 4px' }}
                      >
                        New Ward
                      </InputLabel>
                      <Select>
                        <MenuItem value="General Ward">General Ward</MenuItem>
                        <MenuItem value="Pediatric Ward">
                          Pediatric Ward
                        </MenuItem>
                        <MenuItem value="Maternity Ward">
                          Maternity Ward
                        </MenuItem>
                        <MenuItem value="ICU">ICU</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl sx={{ flex: '1 1 20%' }}>
                      <InputLabel
                        sx={{ backgroundColor: '#f5faff', padding: '0px 4px' }}
                      >
                        Room Number
                      </InputLabel>
                      <Select>
                        <MenuItem value="101">101</MenuItem>
                        <MenuItem value="102">102</MenuItem>
                        <MenuItem value="103">103</MenuItem>
                      </Select>
                    </FormControl>
                    <FormControl sx={{ flex: '1 1 20%' }}>
                      <InputLabel
                        sx={{ backgroundColor: '#f5faff', padding: '0px 4px' }}
                      >
                        Bed Number
                      </InputLabel>
                      <Select>
                        <MenuItem value="B1">B1</MenuItem>
                        <MenuItem value="B2 ">B2</MenuItem>
                        <MenuItem value="B3">B3</MenuItem>
                      </Select>
                    </FormControl>
                    <TextField
                      label="Requested Transfer Date"
                      type="date"
                      sx={{ flex: '1 1 20%' }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </Box>
                </Box>
              </Box>
            </Box>

            {/* More Details*/}
            <Box
              sx={{
                padding: 2,
                backgroundColor: '#f5faff',
                borderRadius: 2,
                marginBottom: 2,
              }}
            >
              <Typography variant="subtitle1" color="grey" marginBottom={2}>
                More Details
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <FormControl sx={{ flex: '1 1 30%' }}>
                  <InputLabel
                    sx={{ backgroundColor: '#f5faff', padding: '0px 4px' }}
                  >
                    Reason for Change
                  </InputLabel>
                  <Select>
                    <MenuItem value="Medical Equipment Required">
                      Medical Equipment Required
                    </MenuItem>
                    <MenuItem value="Shared Room Issues">
                      Shared Room Issues
                    </MenuItem>
                    <MenuItem value="Allergy Concerns">
                      Allergy Concerns
                    </MenuItem>
                    <MenuItem value="Upgrade to Private Room">
                      Upgrade to Private Room
                    </MenuItem>
                    <MenuItem value="Other">Other</MenuItem>
                  </Select>
                </FormControl>
                <FormControl sx={{ flex: '1 1 20%' }}>
                  <InputLabel
                    sx={{ backgroundColor: '#f5faff', padding: '0px 4px' }}
                  >
                    Type of Transfer
                  </InputLabel>
                  <Select>
                    <MenuItem value="Emergency Transfer">
                      Emergency Transfer
                    </MenuItem>
                    <MenuItem value="ICU Transfer">ICU Transfer</MenuItem>
                    <MenuItem value="Ward to ICU Transfer">
                      Ward to ICU Transfer
                    </MenuItem>
                    <MenuItem value="ICU to Ward Transfer">
                      ICU to Ward Transfer
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl sx={{ flex: '1 1 20%' }}>
                  <InputLabel
                    sx={{ backgroundColor: '#f5faff', padding: '0px 4px' }}
                  >
                    Tranfer suggested by
                  </InputLabel>
                  <Select>
                    <MenuItem value="Doctor">Doctor</MenuItem>
                    <MenuItem value="Nurse">Nurse</MenuItem>
                    <MenuItem value="Specialist">Specialist</MenuItem>
                    <MenuItem value="Surgeon">Surgeon</MenuItem>
                    <MenuItem value="Physiotherapist">Physiotherapist</MenuItem>
                  </Select>
                </FormControl>

                <TextField
                  label="Detailed reason for transferring the patient."
                  sx={{ flex: '1 1 100%' }}
                />
                <TextField label="Medical Equipment" sx={{ flex: '1 1 30%' }} />
                <TextField
                  label="Nursing Instructions"
                  sx={{ flex: '1 1 30%' }}
                />
                <TextField label="Dietary Needs" sx={{ flex: '1 1 30%' }} />
              </Box>
            </Box>

            <Box
              sx={{
                padding: 2,
                backgroundColor: '#f5faff',
                borderRadius: 2,
                marginBottom: 2,
              }}
            >
              <Typography variant="subtitle1" color="grey" marginBottom={2}>
                Authorizzation and Approval
              </Typography>
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2 }}>
                <FormControl sx={{ flex: '1 1  Calc(50% - 8px)' }}>
                  <InputLabel
                    sx={{ backgroundColor: '#f5faff', padding: '0px 4px' }}
                  >
                    Requestin Nurse/Doctor
                  </InputLabel>
                  <Select>
                    <MenuItem value="Dr. Aditi Menon">Dr. Aditi Menon</MenuItem>
                    <MenuItem value="Dr. Rajiv Nair">Dr. Rajiv Nair</MenuItem>
                    <MenuItem value="Dr. Priya Sharma">
                      Dr. Priya Sharma
                    </MenuItem>
                    <MenuItem value="Dr. Arjun Reddy">Dr. Arjun Reddy</MenuItem>
                  </Select>
                </FormControl>
                <FormControl sx={{ flex: '1 1 Calc(50% - 8px)' }}>
                  <InputLabel
                    sx={{ backgroundColor: '#f5faff', padding: '0px 4px' }}
                  >
                    Approval by Primary Physician
                  </InputLabel>
                  <Select>
                    <MenuItem value="Dr. Vijay Patel">Dr. Vijay Patel</MenuItem>
                    <MenuItem value="Dr. Reena Mathews">
                      Dr. Reena Mathews
                    </MenuItem>
                    <MenuItem value="Dr. Suresh Babu">Dr. Suresh Babu</MenuItem>
                    <MenuItem value="Dr. Lakshmi Nair">
                      Dr. Lakshmi Nair
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl sx={{ flex: '1 1 Calc(50% - 8px)' }}>
                  <InputLabel
                    sx={{ backgroundColor: '#f5faff', padding: '0px 4px' }}
                  >
                    Nursing Supervisor Approval
                  </InputLabel>
                  <Select>
                    <MenuItem value="Nurse Supervisor Seema Das">
                      Nurse Supervisor Seema Das
                    </MenuItem>
                    <MenuItem value="Nurse Supervisor Anil Gupta">
                      Nurse Supervisor Anil Gupta
                    </MenuItem>
                    <MenuItem value="Nurse Supervisor Maya Verma">
                      Nurse Supervisor Maya Verma
                    </MenuItem>
                    <MenuItem value="Nurse Supervisor Rakesh Menon">
                      Nurse Supervisor Rakesh Menon
                    </MenuItem>
                  </Select>
                </FormControl>
                <TextField
                  label="Date of Approval"
                  type="date"
                  sx={{ flex: '1 1 Calc(50% - 8px)' }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              </Box>
            </Box>

            {/* Register Button */}
            <Box sx={{ textAlign: 'center' }}>
              <Button
                variant="contained"
                color="primary"
                sx={{ padding: '10px 40px', width: '20%' }}
              >
                Save CHanges
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Container>
  );
}

export default BedTransfer;
